import React from 'react';
import '../style/components/footer.css';

const Footer = () => (
  <footer>
    <p>
      Feito com React, CSS e muito carinho por Samuel Melo. &#128156;
    </p>
  </footer>
);

export default Footer;
